module.exports = __webpack_public_path__ + "static/media/dm.bbe2bb05.png";